import React from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@apollo/client";

import { Grid } from "@mui/material";
import logger from "services/logger";

import { useSnackbar } from "components/haven-design/snackbar";

import {
  AdminCreateAccountMutation,
  AdminCreateAccountMutationVariables,
  AdminUserProfileInput,
  PostgresUserRole,
} from "types/gql-types";
import { CreateAccountMutation } from "./queries";
import Form, { FormProps } from "./form";

export enum ErrorCodes {
  DuplicateEmailAccount = "login_email_taken",
  DuplicatePhoneAccount = "login_phone_taken",
  InvalidPassword = "invalid_password",
}

const New: React.FC = () => {
  const navigate = useNavigate();
  const { openSnackbar } = useSnackbar();

  const [createUser] = useMutation<
  AdminCreateAccountMutation,
  AdminCreateAccountMutationVariables
  >(CreateAccountMutation);

  const handleCreateUser: FormProps["onSubmit"] = async (variables, formikHelpers) => {
    try {
      const roles = variables.roles as PostgresUserRole[];
      const profile = variables.profile as AdminUserProfileInput;
      const { data } = await createUser({
        variables: {
          ...variables,
          roles,
          profile: {
            ...profile,
            firstName: profile.firstName && profile.firstName.trim(),
            lastName: profile.lastName && profile.lastName.trim(),
          },
        },
      });
      if (!data?.adminCreateAccount?.id) throw new Error("Something went wrong getting back the created user id!");
      openSnackbar({ message: "Created Account Successfully", status: "success" });
      navigate(`/dash/admin/users/${data.adminCreateAccount.id}`);
    } catch (e) {
      logger.sendError(e as Error);
      openSnackbar({ message: "Creating Account Failed!", status: "error" });
      switch ((e as Error).message) {
        case ErrorCodes.DuplicateEmailAccount:
          formikHelpers.setFieldError("user.loginEmail", "Already exists");
          break;
        case ErrorCodes.DuplicatePhoneAccount:
          formikHelpers.setFieldError("user.loginPhone", "Already exists");
          break;
        case ErrorCodes.InvalidPassword:
          formikHelpers.setFieldError("user.password", "Incorrect password");
          break;
        default:
          console.error(e);
          break;
      }
    }
  };
  return (
    <Grid container spacing={2}><Form onSubmit={handleCreateUser} /></Grid>
  );
};

export default New;
